import { SaleOutcome } from "./SaleRecord.ts";
import {
  OUTCOME_STYLES,
  SALE_OUTCOME_OF_ONE_ORDER_LABELS,
} from "./salesLabels.ts";

export function OutcomeOfOrder({ outcome }: { outcome: SaleOutcome }) {
  const { color, Icon } = OUTCOME_STYLES[outcome];
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap">
      <Icon className="w-3.5 h-3.5 shrink-0" style={{ color }} aria-hidden />
      {SALE_OUTCOME_OF_ONE_ORDER_LABELS[outcome]}
    </span>
  );
}
